"use client";

import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { useGetAPI } from "@/util/api/swr";
import { ConvertLink } from "@/util/tools";
import LoadingPage from "@/util/view/LoadingPage";
import MyImage from "@/util/view/MyImage";
import NoData from "@/util/view/NoData";
import Link from "next/link";

interface ProductSimilar {
    timeStamp: string;
    statusCode: number;
    httpStatus: string;
    message: string;
    data: Data;
}

interface Data {
    count: number;
    rows: Row[];
}

interface Row {
    id: number;
    product_title: string;
    product_title_second: string;
    product_url: string;
    product_image: string;
    product_image_alt: string;
    Albums: Album[];
}

interface Album {
    id: number;
    album_image_src: string;
    album_image_alt: string;
    album_image_main: boolean;
    ProductId: number;
}



const ProductsByListIds = ({ ids, title }: { ids: string | number[]; title: string }) => {
    if (!ids) {
        return <NoData />;
    }
    const parsedIds = typeof ids === 'string' ? JSON.parse(ids) : ids;

    const { data, isLoading } = useGetAPI(`/product-ids?list=[${parsedIds}]`);
    if (isLoading) return <LoadingPage height="400px" />;
    return (
        <div>
            <h2 className="font-bold text-2xl text-ebony p-2">{title}</h2>
            <Carousel
                opts={{
                    loop: true,
                    direction: "rtl",
                }}
                className="w-full"
            >
                <CarouselContent className="-ml-1">
                    {data?.data?.rows?.map((i: Row) => (
                        <CarouselItem
                            key={i.id}
                            className="pl-1 basis-1/2 lg:basis-1/3 xl:basis-1/6"
                        >
                            <Link href={`/product/${ConvertLink(i.product_url)}`} className="h-[255px] w-[200px] p-1 my-2 text-center mx-auto ">
                                <MyImage height={200} width={200}
                                    alt={i.Albums[0]?.album_image_alt ? i.Albums[0]?.album_image_alt : i.product_image_alt}
                                    src={i.Albums[0]?.album_image_src ? i.Albums[0]?.album_image_src : i.product_image}
                                />
                                <div className="p-1 w-[100%] text-right bg-opacity-75 rounded-lg">
                                    <div className="px-1">
                                        <p className="text-[13px] text-center font-semibold text-ebony truncate pt-1">
                                            {i.product_title}
                                        </p>
                                    </div>
                                </div>
                            </Link>
                        </CarouselItem>
                    ))}
                </CarouselContent>
            </Carousel>
        </div>
    )
};

export default ProductsByListIds;